'use strict';
import * as $j_app$002e$002dEndpoints$0024 from "./app.-Endpoints$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$() {
}
export { $c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ as $c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ };
$p = $c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$() {
}
export { $h_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ as $h_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ };
$h_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$.prototype = $p;
$p.avf = (function(endpoint, input, x$3) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_ClientEndpointExts$package$().kE(endpoint, new $j_app$002e$002dEndpoints$0024.$c_Lapp_data_CookieAppAuthData($j_app$002e$002dEndpoints$0024.$m_Lapp_data_CookieAppAuthData$().aAp), input, x$3).qc;
});
var $d_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$, "app.webclient_prelude.exts.EndpointExts$package$", ({
  Iz: 1
}));
export { $d_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ as $d_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ };
var $n_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$;
function $m_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$() {
  if ((!$n_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$)) {
    $n_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ = new $c_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$();
  }
  return $n_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$;
}
export { $m_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ as $m_Lapp_webclient\uff3fprelude_exts_EndpointExts$package$ };
//# sourceMappingURL=app.webclient_prelude.exts.-Endpoint-Exts$package$.js.map
